import clsx from 'clsx';

import { GoogleFontIcon } from '../icons/GoogleFontIcon';

import styles from './clear-button.module.scss';

export type ClearButtonProps = {
  disabled?: boolean;
  loading?: boolean;
  /** set to true to visually hide clear-action, but keep layout */
  hidden?: boolean;
  onClear?: () => void;
};

export function ClearButton({
  disabled,
  loading,
  hidden,
  onClear,
}: ClearButtonProps) {
  return (
    <div
      data-testid="clear"
      className={clsx(
        styles['clear-button'],
        (disabled || loading) && [styles['clear-button--disabled']]
      )}
      style={{
        visibility: !hidden ? 'visible' : 'hidden',
        pointerEvents: !hidden ? 'initial' : 'none',
      }}
      onClick={() => {
        if (!(disabled || loading)) {
          onClear?.();
        }
      }}
    >
      <GoogleFontIcon name="clear" />
    </div>
  );
}
